import { createTheme } from '@mui/material/styles';

const navy = '#01567a';
const navyDark = '#013e5c';
const navyLight = '#1e6d92';
const ink = '#0f2733';
const slate = '#52707d';

const theme = createTheme({
  palette: {
    primary: {
      main: navy,
      light: navyLight,
      dark: navyDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c9a24b',
      light: '#d9bd7c',
      dark: '#a07f2f',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: ink,
      secondary: slate,
    },
    divider: 'rgba(15, 39, 51, 0.12)',
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 800,
      fontSize: '3.5rem',
      lineHeight: 1.1,
      letterSpacing: '-0.02em',
      '@media (max-width:600px)': { fontSize: '2.4rem' },
    },
    h2: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 700,
      fontSize: '2.4rem',
      lineHeight: 1.15,
      letterSpacing: '-0.02em',
      '@media (max-width:600px)': { fontSize: '1.85rem' },
    },
    h3: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.2,
      letterSpacing: '-0.01em',
      '@media (max-width:600px)': { fontSize: '1.6rem' },
    },
    h4: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.25,
      '@media (max-width:600px)': { fontSize: '1.3rem' },
    },
    h5: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.3,
      '@media (max-width:600px)': { fontSize: '1.15rem' },
    },
    h6: {
      fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
      fontWeight: 600,
      fontSize: '1.1rem',
      lineHeight: 1.4,
    },
    subtitle1: { lineHeight: 1.6 },
    body1: { fontSize: '1rem', lineHeight: 1.7, color: slate },
    body2: { lineHeight: 1.65 },
    button: { fontWeight: 600, letterSpacing: '0.01em' },
    overline: {
      fontWeight: 700,
      letterSpacing: '0.14em',
      fontSize: '0.75rem',
    },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          paddingTop: 10,
          paddingBottom: 10,
        },
        contained: {
          backgroundColor: navy,
          color: '#ffffff',
          boxShadow: '0 8px 20px rgba(1, 86, 122, 0.22)',
          '&:hover': {
            backgroundColor: navyDark,
            boxShadow: '0 10px 24px rgba(1, 86, 122, 0.3)',
          },
        },
        outlined: {
          borderColor: 'rgba(1, 86, 122, 0.4)',
          color: navy,
          '&:hover': {
            backgroundColor: 'rgba(1, 86, 122, 0.04)',
            borderColor: navy,
          },
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: '1px solid rgba(15, 39, 51, 0.08)',
          transition: 'transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 14 },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined' },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: 'none' },
      },
    },
  },
});

export default theme;
